var render, staticRenderFns
import script from "./organization_management.vue?vue&type=script&lang=js&"
export * from "./organization_management.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0186d96e')) {
      api.createRecord('0186d96e', component.options)
    } else {
      api.reload('0186d96e', component.options)
    }
    
  }
}
component.options.__file = "found/views/mdm/views/organization_management/organization_management.vue"
export default component.exports